<script>
  import { Bar } from 'vue-chartjs'
  export default {
    extends: Bar,
    name: 'bar-chart',
    props: {
      datasets: Array,
      labels: Array,
      options: Object,
    },
    created () {
      this.chartData.labels = this.labels
      this.chartData.options = this.options
      this.chartData.datasets = this.datasets
      this.charOptions = this.options
    },
    data () {
      return {
        chartData: {
          labels: [],
          datasets: [],
        },
        chartOptions: {},
      }
    },
    watch: {
      datasets (val) {
        this.chartData.datasets = val
      },
    },
    methods: {
      render () {
        this.$nextTick(() => { this.renderChart(this.chartData, this.options) })
      },
    },
  }
</script>
